import type { Action, PageContainer, PageDefinition } from "@judo/model-api";
import { findActionByDefinition } from "./find-action-by-definition";

/**
 * Find the Action in page.actions that matches the container's onInit ActionDefinition.
 * The onInit reference on PageContainer points to an ActionDefinition, and we need to
 * find the corresponding Action in the page that uses that definition.
 *
 * @param page - The PageDefinition containing the actions array
 * @param container - The PageContainer with an optional onInit reference
 * @returns The matching Action, or undefined if no match is found
 */
export function findOnInitAction(page: PageDefinition, container: PageContainer): Action | undefined {
	return findActionByDefinition(page, container.onInit);
}
